import { graphql } from '@prophecy/graphql-types/graphql';
export const getOrCreateProjectShareLinkMutation = graphql(`
  mutation getOrCreateProjectShareLink(
    $projectUID: String!
    $fabricUID: String
    $entityUri: String
    $linkType: LinkType
    $conversationId: String
  ) {
    getOrCreateProjectShareLink(
      projectUID: $projectUID
      fabricUID: $fabricUID
      entityUri: $entityUri
      linkType: $linkType
      conversationId: $conversationId
    ) {
      link
      shareScope
      linkType
    }
  }
`);
export const updateShareScopeMutation = graphql(`
  mutation updateShareScope($shareId: String!, $shareScope: ShareScope!) {
    updateShareScope(shareId: $shareId, shareScope: $shareScope)
  }
`);
export const listSharedProjectsByUrlQuery = graphql(`
  query listSharedProjectsByUrl {
    listSharedProjectsByUrl {
      project {
        name
        id
      }
      shareUID
    }
  }
`);
export const cloneSharedProjectMutation = graphql(`
  mutation cloneSharedProject($uid: String!, $fabricUID: String!) {
    cloneSharedProject(uid: $uid, fabricUID: $fabricUID) {
      _id
    }
  }
`);
